import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-profile-about-us",
    templateUrl: "./profile-about-us.component.html",
    styleUrls: ["./profile-about-us.component.scss"]
})
export class ProfileAboutUsComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
